export default __webpack_public_path__ + "static/media/LOGO_3.4642f586.svg";